// Keep in sync with .modal-dialog
// Note: the value here is the full width of the modal (600), minus 16px of padding
// on the left & right (.modal-body)
export const MODAL_WIDTH = 578;

export enum ModalPreferences {
  TRANSFER_MODAL_INPUT_TYPE = 'transferModal.inputType',
}
